"use strict";

exports.__esModule = true;
exports.default = clone;

/**
 * Copie toutes les clés (de premier niveau) d’un objet à l’autre.
 * @param {object} source
 * @param {object} target
 */
function clone(source, target) {
  for (const attributeKey of Object.keys(source)) {
    target[attributeKey] = source[attributeKey];
  }

  return target;
}